export const getMinsFromNow = (date) => {
  const now = new Date();
  const taskDate = new Date(date);
  const diff = now - taskDate;
  const mins = Math.floor(diff / 60000);
  return mins;
};
